import { Grid } from 'antd';
import { useEffect, useState } from 'react';

const responsivePos = {
  pos: '(max-width: 1400px)'
};

const { useBreakpoint: useVBreakpoint } = Grid;

const useBreakpoint = () => {
  const [posMediaQuery, setPosMediaQuery] = useState<Partial<MediaQueryListEvent>>({
    matches: window.innerWidth < 1400,
    media: ''
  });

  // 레거시 addListener 경로는 MediaQueryList 자신을 넘겨 참조가 매번 같으므로, 새 객체로 담아 리렌더 bailout을 피한다
  const handler = (e: MediaQueryListEvent | MediaQueryList) => {
    setPosMediaQuery({ matches: e.matches, media: e.media });
  };
  useEffect(() => {
    const mql = window.matchMedia(responsivePos.pos);
    // 레거시 Edge(EdgeHTML)·IE11은 MediaQueryList.addEventListener를 지원하지 않아 addListener로 폴백
    if (mql.addEventListener) {
      mql.addEventListener('change', handler);

      return () => {
        mql.removeEventListener('change', handler);
      };
    }

    mql.addListener(handler);

    return () => {
      mql.removeListener(handler);
    };
  }, []);
  const screens = useVBreakpoint();

  const breakpoint = {
    ...screens,
    pos: posMediaQuery.matches
  };
  return breakpoint;
};

export default useBreakpoint;
